import { IpPublicService } from '../../../../../services/ip-public.service';
import { Component, OnDestroy, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { AlertService } from '../../../../../services/alert.service';
import { ModalService } from '../../../../../services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map } from 'rxjs';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { HitoService } from '../../../services/hito.service';
import { ResumenEjecutivoService } from '../../../services/resumen-ejecutivo.service';
import { Resumen } from '../../../models/resumen';
import { UserService } from 'src/app/modulos/admin/services/user.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { DatePipe } from '@angular/common';
import { UsuarioRedux } from 'src/app/models/usuario.model';
@Component({
  selector: 'app-resumen-ejecutivo',
  templateUrl: './resumen-ejecutivo.component.html',
  styleUrls: ['./resumen-ejecutivo.component.css'],
})
export class ResumenEjecutivoComponent implements OnInit, OnDestroy {
  public formResumenAll: UntypedFormGroup;
  public formFechasResumen: UntypedFormGroup;
  public currentUserRedux: UsuarioRedux = null;
  public formSubmitted = false;
  public currentAmbiente: any;
  public ipAddress!: string;
  public buffer: any;
  public dataUsuario: any[] = [];
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public modalFechasResumenEjecutivo: string = 'fechasControlResumenEjecutivo';
  public submitted = false;
  public modalResumenEjecutivo: string = 'modalResumen';
  public nameResumen = 'Resumen ejecutivo';
  public idSprProyecto: number = 0;
  public idSprUsuario!: number;
  public dataResumenEjecutivo: any;
  public proyectoInput: any = null;
  public nombreProyecto = '';
  public dataOrdenadaResumenEjecutivo: any;
  public nombreMes!: any;
  public idSprNivel: number = 0;
  pipe = new DatePipe('en-US');
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  idRolAnalistaMetodologico = ConstantsCatalogosIdService.ANALISTA_METODOLOGICO;
  public idSprRolPrincipal: number = 0;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;
  datePipe: any;

  @Input() set data(Proyectos: any) {
    this.idSprProyecto = Proyectos.idSprProyecto;
    this.nombreProyecto = Proyectos.nombreProyecto;
    if (this.idSprProyecto != undefined) {
      this.initApp();
    }
  }
  
  @Input() set proyecto(proyectoActual: any) {
    this.proyectoInput = proyectoActual;
  }
  
 
  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprRolPrincipal = response.rolSeleccionado.idSprRol;
    });
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
    });
  }
 

  initApp() {
    this.getDataAll();
    this.setDataTable();
    this.getIpPublic();
  }

  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private fb: FormBuilder,
    private alert: AlertService,
    private ip: IpPublicService,
    public  modal: ModalService,
    private hitoService: HitoService,
    private resumenEjecutivoService: ResumenEjecutivoService,
    private usuarioService: UserService,
    private store: Store<AppState>
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentAmbiente = JSON.parse(this.buffer);
    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.setForm();
  }

  get etapaForm() {
    return this.formResumenAll.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.formResumenAll = this.fb.group({
      idSprResumenEjecutivo: [],
      mes: [],
      resumen: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });
    this.formFechasResumen = this.fb.group({
      idSprResumenEjecutivo: [],
      fechaInicio: [''],
      fechaFin:  [''],
    });
}

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  getDataAll() {
    forkJoin([
      this.resumenEjecutivoService.list('?idSprProyecto=' + this.idSprProyecto),
      this.usuarioService.list()
    ])
      .pipe(
        map(([dataResumenEjecutivo, usuarios]) => {
          this.dataResumenEjecutivo = dataResumenEjecutivo;
          this.dataUsuario = usuarios;
        })
        )
        .subscribe((resp) => {
          this.orderAscResumenEjecutivo();
      });
  }

  public orderAscResumenEjecutivo() {
    this.dataOrdenadaResumenEjecutivo = this.dataResumenEjecutivo.sort(
      (a, b) => a.orden - b.orden
    );
  }

  onSubmitResumenEjecutivo() {
    this.formSubmitted = true;
    this.formResumenAll.value.idSprProyecto = this.idSprProyecto;
    this.formResumenAll.value.usuario = this.idSprUsuario;
    this.formResumenAll.value.ip = this.ipAddress;
    if (this.formResumenAll.value.idSprResumenEjecutivo == null || this.formResumenAll.value.idSprResumenEjecutivo == ' ') {
      this.resumenEjecutivoService.create(this.formResumenAll.value).subscribe(
        (resp) => {
          this.closeModalEtapa();
          this.alert.createOk();
          this.initApp();
        },
        (err) => {
          this.alert.createError();
        }
      );
    } else {    
      this.resumenEjecutivoService.update(this.formResumenAll.value).subscribe(
        (resp) => {
          this.closeModalEtapa();
          this.closeModalEtapaFechas();
          this.alert.updateOk();
          this.initApp();
        },
        (err) => {
          this.alert.updateError();
        }
      );
    }
    return true;
  }

  onSubmit() {
    this.formSubmitted = true;
    this.formFechasResumen.value.idSprProyecto = this.idSprProyecto;
    this.formFechasResumen.value.usuario = this.idSprUsuario;
    this.formFechasResumen.value.ip = this.ipAddress;
    if (this.formFechasResumen.value.idSprResumenEjecutivo == null || this.formFechasResumen.value.idSprResumenEjecutivo == ' ') {
      this.resumenEjecutivoService.create(this.formFechasResumen.value).subscribe(
        (resp) => {
          this.closeModalEtapa();
          this.alert.createOk();
          this.initApp();
        },
        (err) => {
          this.alert.createError();
        }
      );
    } else {
      this.resumenEjecutivoService.update(this.formFechasResumen.value).subscribe(
        (resp) => {
          this.closeModalEtapa();
          this.closeModalEtapaFechas();
          this.alert.updateOk();
          this.initApp();
        },
        (err) => {
          this.alert.updateError();
        }
      );
    }
    return true;
  }

  update(obj: Resumen) {
    let fechaInicio = obj.fechaInicio;
    let fechaFin = obj.fechaFin;
    const fechaActual = new Date();
    let fechaActualComparar: string;
    fechaActualComparar = this.pipe.transform(fechaActual, 'yyyy-MM-dd');
    this.nombreMes = obj.nombre;
    if (fechaActualComparar >= fechaInicio.toString() && fechaActualComparar <= fechaFin.toString()) {
      this.openModalEtapa();
    } else if (fechaActualComparar <= fechaInicio.toString() && fechaActualComparar <= fechaFin.toString()) {
      this.alert.warning(
        '¡Atención!',
        'Aún no se puede ingresar el resumen ejecutivo.'
      );
    } else {
      this.alert.warning(
        '¡Atención!',
        'Fecha de Modificación del Resumen Ejecutivo fuera de vigencia,Póngase en contacto con el administrador!'
      );
    }
   this.formResumenAll.patchValue({
      idSprResumenEjecutivo: obj.idSprResumenEjecutivo,
      idSprProyecto: obj.idSprProyecto,
      nombre: obj.nombre,
      resumen: obj.resumen,
      estado: obj.estado,
    });
  }

  delete(idRegister: number) {
    this.modal.open('delete-etapa');
    this.idDeleteRegister = idRegister;
  }

  /////////////////VERIFICA  RLACIONADOS///////////////////////
  verifyHito() {
    return this.hitoService
      .list(`?idSprResumenEjecutivo=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  /////////////////////////////////////////////////////////////////////////
  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyHito();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    //###################################################################################
    if (confirmDelete) {
      this.resumenEjecutivoService
        .delete({
          idSprResumenEjecutivo: this.idDeleteRegister,
          usuario: this.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.closeId('delete-etapa');
            this.alert.deleteOk();
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    } else {
      this.alert.warning(
        'ALERTA!',
        'No se puede borrar este registro por que tiene hitos relacionados'
      );
    }
  }

  cosultaResponsable(id: number, dataUsuarios: any[]) {
    return dataUsuarios?.filter((respUser) => {
      return respUser.idSprUsuario === id;
    });
  }

  openModalEtapa() {   
    this.onResetForm();
    this.modal.open(this.modalResumenEjecutivo);
  }

  openResumenFechas(obj: any) {
    this.nombreMes = obj.nombre;
    this.formFechasResumen.patchValue({
      idSprResumenEjecutivo: obj.idSprResumenEjecutivo,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
    });
    this.formFechasResumen.get('fechaInicio')?.disable();
    this.modal.open(this.modalFechasResumenEjecutivo);
  }

  closeModalEtapa() {
    this.modal.closeId(this.modalResumenEjecutivo);
  }

  closeModalEtapaFechas() {
    this.modal.closeId(this.modalFechasResumenEjecutivo);
  }

  onResetForm() {
    this.formSubmitted = false;
    this.formResumenAll.reset();
  }
}
